import { IFIReportType } from 'shared'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { useProjectSettingsContext } from '../../../../ProjectSettingsContext'
import { useState } from 'react'
import DirtyHeader from '../../components/DirtyHeader'
import EnabledIndicator from '../../components/EnabledIndicator'
import DensityTestEditPanel from './components/DensityTestEditPanel'
import { DensityTestViewPanel } from './components/DensityTestViewPanel'

const useDensityTestPanel = (): CIMSCollapsePanelOptions => {
  const {
    densityTestIFISettings: { data },
    canEdit,
  } = useProjectSettingsContext()
  const [isDirty, setIsDirty] = useState<boolean>(false)

  return {
    header: {
      children: (
        <DirtyHeader title={IFIReportType.DensityTest.type} isDirty={isDirty} />
      ),
    },
    key: IFIReportType.DensityTest.id,
    extra: {
      children: <EnabledIndicator enabled={data?.enabled} />,
    },
    children: canEdit ? (
      <DensityTestEditPanel {...{ isDirty, setIsDirty }} />
    ) : (
      <DensityTestViewPanel />
    ),
  }
}

export default useDensityTestPanel
